import { render, staticRenderFns } from "./PresetTreatmentBrowser.vue?vue&type=template&id=4b98d2a8&scoped=true&"
import script from "./PresetTreatmentBrowser.vue?vue&type=script&lang=js&"
export * from "./PresetTreatmentBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98d2a8",
  null
  
)

export default component.exports